interface Props {
  type?: string
  label?: string
}
const ProductLabel = ({ label }: Props) => {
  switch (label) {
    case 'new':
      return (
        <span
          className={`label mr-2 block h-6 w-max items-center justify-center rounded bg-primary-second px-2 text-center font-bold uppercase leading-6 text-white`}
        >
          New
        </span>
      )
    case 'hot':
      return (
        <span
          className={`label mr-2 block h-6 w-max items-center justify-center rounded bg-primary-second px-2 text-center font-bold uppercase leading-6 text-white`}
        >
          hot
        </span>
      )
    case 'comingSoon':
      return (
        <span
          className={`label mr-2 block h-6 w-max items-center justify-center rounded bg-primary-base px-2 text-center font-bold uppercase leading-6 text-white`}
        >
          coming soon
        </span>
      )

    default:
      return <></>
  }
}
export default ProductLabel
